import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { arenaService } from '@/services/arena';
import useVuelidate from '@vuelidate/core';
import { integer } from '@vuelidate/validators';
import { useRoute } from 'vue-router';

export function useArenaCycleRank() {
    const route = useRoute();

    const { arenaId, cycleId } = route.params;

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            accountId: { type: 'number', default: null },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const validations = {
        accountId: { integer }
    };

    const v$ = useVuelidate(validations, query);

    const { list, total, fetchList } = useBaseListView({
        request: arenaService.rank.list,
        paramsBuilder: () => ({ ...query, arenaId, cycleId }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            canFetch: () => {
                v$.value.$touch();
                return !v$.value.$invalid;
            }
        }
    });

    return { query, list, total, fetchList, v$ };
}
